import sectionStyles from "@/asserts/styles/formSection.module.less";
import type { EditInquiryFormValues } from "../../type";
import { Button, Empty, Form, Row, Tag } from "antd";
import ModalSectionHeader from "@/components/ui/ModalSectionHeader";
import { SearchSupplier } from "./SearchSupplier";
import { useEffect, useState } from "react";
import styles from "./SupplierFormFields.module.less";
import { SupplierPageVo } from "@/types/apis";
import { CloseOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

type SelectedSupplier = {
  id: number;
  supplierName?: string;
  supplierUsName?: string;
};
export function SupplierFormFields({ disabled }: { disabled: boolean }) {
  const { t } = useTranslation("inquiryManagement");
  const form = Form.useFormInstance<EditInquiryFormValues>();
  const [selectedSuppliers, setSelectedSuppliers] = useState<
    SelectedSupplier[]
  >([]);

  const supplierDetailList = Form.useWatch("supplierDetailList", form);

  useEffect(() => {
    if (!supplierDetailList || supplierDetailList.length === 0) {
      return;
    }
    setSelectedSuppliers(
      supplierDetailList.map((s) => {
        return {
          id: s.supplierId,
          supplierName: s.supplierName,
          supplierUsName: s.supplierUsName,
        };
      }),
    );
  }, [supplierDetailList]);

  const onSelect = (rows?: SupplierPageVo[]) => {
    if (!rows) {
      return;
    }
    setSelectedSuppliers((prev) => {
      const newSuppliers = rows.filter(
        (row) => !prev.some((item) => item.id === row.id),
      );
      const next = [...prev, ...newSuppliers];
      form.setFieldValue(
        "supplierList",
        next.map((item) => item.id),
      );
      return next;
    });
  };

  return (
    <div className={sectionStyles.formSection}>
      <Form.Item<EditInquiryFormValues> name="supplierList" hidden noStyle />

      <Form.Item<EditInquiryFormValues>
        name="supplierDetailList"
        hidden
        noStyle
      />
      <ModalSectionHeader title={t("供应商选择")} />

      <div className={sectionStyles.sectionBody}>
        <Row hidden={disabled}>
          <SearchSupplier onSelect={onSelect} />
        </Row>

        {selectedSuppliers.length === 0 && <Empty />}
        <div className={styles.tagContainer}>
          {selectedSuppliers.map((item) => (
            <Tag
              key={item.id}
              className={styles.tag}
              closeIcon={disabled ? null : <CloseOutlined />}
              onClose={() => {
                const next = selectedSuppliers.filter((i) => i.id !== item.id);
                form.setFieldValue(
                  "supplierList",
                  next.map((item) => item.id),
                );
                setSelectedSuppliers(next);
              }}
            >
              {item.supplierName || item.supplierUsName}
            </Tag>
          ))}
        </div>

        {selectedSuppliers.length > 0 && (
          <div className={styles.buttonContainer}>
            {t("共count个供应商").replace(
              "{count}",
              selectedSuppliers.length.toString(),
            )}
            <Button
              style={{ marginLeft: 12 }}
              variant="outlined"
              color="danger"
              onClick={() => {
                form.setFieldValue("supplierList", []);
                setSelectedSuppliers([]);
              }}
            >
              {t("清空")}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
